module.exports = __webpack_public_path__ + "img/特斯拉实力超群的神经网络.b2457a6e.png";